import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeletePhaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
